import { createRouter, createWebHistory } from 'vue-router';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { applyLocale } from './utils';
import { routes } from './constants';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      ...routes.dashboard,
      component: (): any => import('@/views/Dashboard/Dashboard.vue')
    }
  ]
});

router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  applyLocale(to);
  next();
});

export { router };
